import Vue from "vue";
import Vuex from "vuex";

// modules
import albums from "@/store/albums";
import artists from "@/store/artists";
import directions from "@/store/directions";
import genres from "@/store/genres";
import modal from "@/store/modal";
import oauth from "@/store/oauth";
import page from "@/store/page";
import pages from "@/store/pages";
import personal from "@/store/personal";
import player from "@/store/player";
import playlists from "@/store/playlists";
import promo from "@/store/promo";
import queue from "@/store/queue";
import search from "@/store/search";
import tracks from "@/store/tracks";
import user from "@/store/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    albums,
    artists,
    directions,
    genres,
    modal,
    oauth,
    page,
    pages,
    personal,
    player,
    playlists,
    promo,
    queue,
    search,
    tracks,
    user
  }
});
